import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Card, CardContent, Notice } from 'telia-front-react';
import LanguageStore from '../../stores/LanguageStore';
import BranchSpecialHours from './BranchSpecialHours';
import { SpecialHour, TranslationMap } from '../common/ReservationInterfaces';

interface BranchSpecialInfoProps {
  additionalDescription?: TranslationMap;
  languageStore?: LanguageStore;
  specialHours?: SpecialHour[];
}
@observer
class BranchSpecialInfo extends React.Component<BranchSpecialInfoProps> {
  public render() {
    const {
      additionalDescription,
      specialHours,
      languageStore: { currentLanguage },
    } = this.props;

    return (
      <Card>
        <CardContent>
          <Notice size="small">
            {specialHours && <BranchSpecialHours specialHours={specialHours} />}
            <div
              dangerouslySetInnerHTML={{
                __html: additionalDescription[currentLanguage] ? additionalDescription[currentLanguage] : additionalDescription.et,
              }}
            />
          </Notice>
        </CardContent>
      </Card>
    );
  }
}

export default inject('languageStore')(BranchSpecialInfo);
